import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Modal} from 'components/ui';
import styles from './FocusModeOfflineModal.module.scss';

/**
 * FocusModeOfflineModal
 *
 * Blocking overlay shown when the student loses connectivity during an
 * active Focus Mode trail. Disappears automatically when the connection
 * is restored. Not closeable — no button, no backdrop click.
 */
function FocusModeOfflineModal(): JSX.Element {
  return (
    <Modal
      isOpen
      onClose={() => {}}
      clickOutsideToClose={false}
      buttonClose={false}
      minWidth={340}
      maxWidth={480}
      vw={92}
    >
      <div className={styles.container}>
        <section className={styles.header}>
          <div className={styles.headerIcon}>
            <FontAwesomeIcon icon="wifi-slash" />
          </div>

          <h2 className={styles.title}>Conexão interrompida</h2>
        </section>

        <div className={styles.timerBanner}>
          <FontAwesomeIcon
            icon="hourglass-start"
            className={styles.timerIcon}
          />
          <span>
            <strong>O timer continua contando.</strong> Aguarde a reconexão para
            retomar a atividade.
          </span>
        </div>

        <section className={styles.body}>
          <ul>
            <li>
              <FontAwesomeIcon
                icon="check-circle"
                className={styles.listIconSuccess}
              />
              <span>
                Suas respostas estão salvas e serão enviadas quando a conexão
                voltar.
              </span>
            </li>

            <li>
              <FontAwesomeIcon icon="lock" className={styles.listIcon} />
              <span>
                A atividade será liberada automaticamente ao reconectar.
              </span>
            </li>
          </ul>
        </section>

        <div className={styles.reconnecting}>
          <FontAwesomeIcon
            icon="circle-notch"
            spin
            className={styles.spinIcon}
          />
          <span>Aguardando reconexão...</span>
        </div>
      </div>
    </Modal>
  );
}

export default FocusModeOfflineModal;
